import { arcgisURL } from "@/config/api-config";

const oilPalmPolygonLayer = {
  title: "Niger Delta Oil Palm",
  url: arcgisURL + "OilPalmCluster/FeatureServer",
  opacity: 0.8,
  copyright: "",
  geometryType: "polygon",
  renderer: {
    type: "simple",
    symbol: {
      type: "simple-fill",
      color: "#964B00",
      outline: {
          color: "rgba(150, 75, 0, 1%)",
          width: 0.2,
      },
  },
  },
  popupTemplate: {
    title: "Oil Palm Clusters - {expression/roundedArea} ha",

    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "Area_ha",
            label: "Area Size (ha)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "ffb_yield",
            label: "Fresh Fruit Bunches yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "cpo_yield",
            label: "Crude Palm Oil yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "pko_yield",
            label: "Palm Kernel Oil yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "pkn_yield",
            label: "Palm Kernel Nuts yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "pks_yield",
            label: "Palm Kernel Shell yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
          {
            fieldName: "fibr_yld",
            label: "Fibre yield (T)",
            visible: true,
            format: {
              places: 0,
              digitSeparator: true,
            },
          },
        //   {
        //     fieldName: "lga",
        //     label: "LGA",
        //     visible: true,
        //   },
          {
            fieldName: "state",
            label: "State",
            visible: true,
          },
        ],
      },
    ],

    expressionInfos: [
      {
        name: "roundedArea",
        title: "Rounded Area",
        expression: "Round($feature.Area_ha, 0)",
      },
    ],
  },
};

export default oilPalmPolygonLayer;
